/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import L from "../Lang";
import Card from "../Card";
import FormInput from "../FormInput";
import AppActions from "../AppActions";
import ConfirmButton from "../ConfirmButton";

class MyInfo extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
    }

    submit = (e) => {
        e?.preventDefault();
    }


    render() {
        return <div className="container-fluid">
            <h1><L>My Information</L></h1>
            <form onSubmit={this.submit}>

                <AppActions>
                    <ConfirmButton lg submit icon="faSave">
                        <L>Save</L>
                    </ConfirmButton>
                </AppActions>

                <Card title="User Demographic">
                    <div className="row">
                        <div className="col-md-6">
                            <FormInput model={this.state.info} name="firstName" label="First Name" required />
                        </div>
                        <div className="col-md-6">
                            <FormInput model={this.state.info} name="lastName" label="Last Name" required />
                        </div>
                    </div>
                </Card>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(MyInfo);